module.exports = __webpack_public_path__ + "static/img/2.9041de7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/avatar/2.png
// module id = MxaQ
// module chunks = 1